import { skyFoundationSettings } from '../services/configs/configs-service';
import logger from '../services/logging/logging-service';

const premiumCommonHTTPResponseHandler = {
  200: async (response) => ({ payload: await response.json() }),
  400: (response, productConfig) => {
    throw new Error(response.status, { cause: response.statusText });
  },
  403: (response, productConfig) => {
    throw new Error(response.status, { cause: response.statusText });
  },
  500: (response, productConfig) => {
    throw new Error(response.status, { cause: response.statusText });
  },
  default: (response) => {
    throw new Error(response.status, { cause: response.statusText });
  },
};

const fetchPricingTableHTTPResponseHandler = {
  ...premiumCommonHTTPResponseHandler,
  401: (response) => ({
    redirectTo: skyFoundationSettings.getLoginBaseUrl(),
  }),
};

const fetchUserSubscriptionHTTPResponseHandler = {
  ...premiumCommonHTTPResponseHandler,
  401: (response) => ({
    redirectTo: skyFoundationSettings.getLoginBaseUrl(),
  }),
};

const BFFConfig = {
  timeout: 10000,
  api: {
    fetchPricingTable: {
      handler: fetchPricingTableHTTPResponseHandler,
    },
    fetchUserSubscription: {
      handler: fetchUserSubscriptionHTTPResponseHandler,
    },
  },
};

const premiumFetch = async (url, timeout) => {
  const abortController = new AbortController();
  const signal = abortController.signal;

  const timeoutId = setTimeout(() => abortController.abort(), timeout);

  const response = await fetch(url, {
    mode: 'cors',
    credentials: 'include',
    headers: {
      origin,
    },
    signal,
  });

  clearTimeout(timeoutId);

  return response;
};

const responseHandler = (handler, response, productConfig) => {
  return handler[response.status]
    ? handler[response.status](response, productConfig)
    : handler.default(response, productConfig);
};

export const premiumBFF = {
  async fetchPricingTable(productCode) {
    const {
      timeout,
      api: {
        fetchPricingTable: { handler },
      },
    } = BFFConfig;
    const url = new URL(skyFoundationSettings.getPremiumPricingTableURL());
    url.searchParams.append('product_code', productCode);
    return responseHandler(handler, await premiumFetch(url.toString(), timeout), {});
  },
  async fetchUserSubscription(productCode, { returnURL }) {
    const {
      timeout,
      api: {
        fetchUserSubscription: { handler },
      },
    } = BFFConfig;
    const url = new URL(skyFoundationSettings.getPremiumCustomerPortalURL());
    url.searchParams.append('product_code', productCode);
    url.searchParams.append('return_url', returnURL);
    return responseHandler(handler, await premiumFetch(url.toString(), timeout), {});
  },
};
